import $ from 'jquery';
import 'jquery';
import 'slick-carousel';

// import SimpleBar from 'simplebar';
// import lazyframe from "lazyframe";

// Import Bootstrap
import * as bootstrap from 'bootstrap';

// Import includes
import './includes/_navigation';
import './includes/_affixed';
import './includes/_anchor'

import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

window.$ = $;
window.jQuery = $;


$(() => {


  if ($('.clients-slider').length) {
    clients_slider();
  }
  if ($('.testimonies-slider').length) {
    testimonies_slider();
  }

});


function isMobileActive() {
  var mobileNavBreakpoint = 992;
  if ($(window).width() < mobileNavBreakpoint) {
    return true;
  }
  return false;
}



function clients_slider() {
  const $slider = $('.clients-slider');

  $slider.slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToScroll: 5,
    slidesToShow: 5,
    rows: 0,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      }
    ]
  });

  const $block = $slider.closest('.wp-block');
  const $prev = $block.find('.prev');
  const $next = $block.find('.next');

  if ($prev.length) {
    $prev.on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickPrev');
    });
  }

  if ($next.length) {
    $next.on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickNext');
    });
  }
}



function testimonies_slider() {
  const $slider = $('.testimonies-slider');

  $slider.slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 0,
    fade: true,
    // responsive: [
    //   {
    //     breakpoint: 991,
    //     settings: {
    //       slidesToShow: 4,
    //       slidesToScroll: 4,
    //     }
    //   },
    //   {
    //     breakpoint: 767,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 3,
    //     }
    //   }
    // ]
  });

  const $block = $slider.closest('.wp-block');
  const $prev = $block.find('.prev');
  const $next = $block.find('.next');

  if ($prev.length) {
    $prev.on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickPrev');
    });
  }

  if ($next.length) {
    $next.on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickNext');
    });
  }
}


// function init_lazyframe() {
//   // Passing a nodelist
//   let elements = document.querySelectorAll(".lazyframe");
//   lazyframe(elements);
// }


